"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = exports.Forbidden = exports.ForbiddenReason = exports.DownloadUrl = exports.Status = exports.CreateResult = exports.Id = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Job = __importStar(require("../../../../../job"));
const openapi_1 = require("../../../../openapi");
const Common = __importStar(require("../common"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Fleet.ExportJob';
/*
 * `controllers/v2/fleet/export-job-http.ts`: the HTTP scaffolding shared by
 * the devices and alarms CSV export jobs. Both routers mount the same three
 * routes under their own prefix; the filter snapshot is the only difference.
 */
/** `ExportJobPathParams.id` */
exports.Id = Job.JobId.annotations({
    identifier: `${exports.NAMESPACE}.Id`,
    title: 'Export job id',
    description: 'Export job identifier, as returned by the create route',
});
/** `ExportJobCreateResponse`: `ExportJobRecord.pick('id', 'status', 'createdAt')` */
exports.CreateResult = Job.ExportJobRecord.pipe(effect_1.Schema.pick('id', 'status', 'createdAt')).annotations({
    identifier: `${exports.NAMESPACE}.CreateResult`,
    title: 'ExportJobCreateResponse',
    description: 'The queued export job',
});
/** `ExportJobStatusResponse`: the record without the signed URL and the raw error details. */
exports.Status = Job.ExportJobRecord.pipe(effect_1.Schema.omit('downloadUrl', 'downloadUrlExpiresAt', 'errorDetails')).annotations({
    identifier: `${exports.NAMESPACE}.Status`,
    title: 'ExportJobStatusResponse',
    description: 'Export job lifecycle. `rowCount`, `filePath` and `fileName` are set once the job succeeded; `errorCode` once it failed.',
});
/** `ExportJobDownloadResponse`: a short-lived signed URL, not the CSV bytes. */
exports.DownloadUrl = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.DownloadUrl`,
    title: 'ExportJobDownloadResponse',
    description: 'Signed download URL for the CSV file (`text/csv; charset=utf-8`, `Content-Disposition: attachment`), valid for one hour',
});
/** 403 bodies the export routes answer with (`buildForbiddenResponse(<message>)`). */
exports.ForbiddenReason = effect_1.Schema.Literal('TENANT_SCOPE_FORBIDDEN', 'EXPORT_JOB_FORBIDDEN', 'EXPORT_DOWNLOAD_NOT_READY').annotations({
    identifier: `${exports.NAMESPACE}.ForbiddenReason`,
    description: 'TENANT_SCOPE_FORBIDDEN: a requested tenant is outside the caller scope; EXPORT_JOB_FORBIDDEN: the job belongs to another user or tenant scope; EXPORT_DOWNLOAD_NOT_READY: the job has not succeeded or has no file yet',
});
exports.Forbidden = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        type: effect_1.Schema.Literal('ForbiddenError'),
        message: exports.ForbiddenReason,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Forbidden`,
    title: 'Export Forbidden',
    description: 'The caller may not act on this export job',
    [platform_1.HttpApiSchema.AnnotationStatus]: 403,
});
const PathParams = effect_1.Schema.Struct({ id: exports.Id });
/**
 * The three export routes of one CSV export kind, to be added to a group
 * whose prefix is the router base (`/fleet/alarms`, `/fleet/devices`).
 *
 * @param kind operation-id infix and prose subject, e.g. `Alarms`
 * @param body the create payload (`{ filterSnapshot }`) of this export kind
 * @param filename the default download filename
 */
const routes = (kind, body, filename) => {
    const subject = kind.toLowerCase();
    const create = platform_1.HttpApiEndpoint.post(`create${kind}ExportJob`) `/export/jobs`
        .setPayload(body)
        .addSuccess(openapi_1.Response.Success(exports.CreateResult).annotations({
        description: 'The export job was queued',
    }), { status: 201 })
        .addError(exports.Forbidden)
        .annotate(platform_1.OpenApi.Title, `Create ${kind} Export Job`)
        .annotate(platform_1.OpenApi.Description, `Queues a CSV export of the ${subject} matching the filter snapshot, scoped to the tenants visible to the caller, and answers 201 with the job id. ` +
        'Answers 403 `TENANT_SCOPE_FORBIDDEN` when the snapshot names a tenant outside that scope. ' +
        'A dedicated rate limiter caps the number of jobs a user may create.')
        .pipe(Common.withAdminGuard, openapi_1.Error.withLegacyV2StandardErrors);
    const status = platform_1.HttpApiEndpoint.get(`get${kind}ExportJobStatus`) `/export/jobs/${platform_1.HttpApiSchema.param('id', exports.Id)}`
        .setPath(PathParams)
        .addSuccess(openapi_1.Response.Success(exports.Status).annotations({
        description: 'Export job status',
    }))
        .addError(exports.Forbidden)
        .addError(openapi_1.Error.NotFound)
        .annotate(platform_1.OpenApi.Title, `Get ${kind} Export Job Status`)
        .annotate(platform_1.OpenApi.Description, `Returns the lifecycle of one ${subject} export job. ` +
        'Answers 404 when no job has that id or the job is of another export type, 403 `EXPORT_JOB_FORBIDDEN` when it was created by another user or outside the caller tenant scope.')
        .pipe(Common.withAdminGuard, openapi_1.Error.withLegacyV2StandardErrors);
    const download = platform_1.HttpApiEndpoint.get(`get${kind}ExportJobDownload`) `/export/jobs/${platform_1.HttpApiSchema.param('id', exports.Id)}/download`
        .setPath(PathParams)
        .addSuccess(openapi_1.Response.Success(exports.DownloadUrl).annotations({
        description: 'Signed download URL',
    }))
        .addError(exports.Forbidden)
        .addError(openapi_1.Error.NotFound)
        .annotate(platform_1.OpenApi.Title, `Get ${kind} Export Job Download`)
        .annotate(platform_1.OpenApi.Description, `Returns a short-lived signed URL for the CSV of a succeeded ${subject} export job (default filename \`${filename}\`). ` +
        'The body is the URL, not the file. Answers 403 `EXPORT_DOWNLOAD_NOT_READY` while the job has not succeeded, ' +
        '404 and 403 `EXPORT_JOB_FORBIDDEN` as the status route.')
        .pipe(Common.withAdminGuard, openapi_1.Error.withLegacyV2StandardErrors);
    return [create, status, download];
};
exports.routes = routes;
//# sourceMappingURL=export-job.js.map